const COUNTRY_TIMEZONE_MAP = {
  'united states': 'America/New_York',
  'usa': 'America/New_York',
  'us': 'America/New_York',
  'canada': 'America/Toronto',
  'brazil': 'America/Sao_Paulo',
  'united kingdom': 'Europe/London',
  'uk': 'Europe/London',
  'france': 'Europe/Paris',
  'germany': 'Europe/Berlin',
  'spain': 'Europe/Madrid',
  'italy': 'Europe/Rome',
  'netherlands': 'Europe/Amsterdam',
  'switzerland': 'Europe/Zurich',
  'turkey': 'Europe/Istanbul',
  'egypt': 'Africa/Cairo',
  'south africa': 'Africa/Johannesburg',
  'nigeria': 'Africa/Lagos',
  'saudi arabia': 'Asia/Riyadh',
  'ksa': 'Asia/Riyadh',
  'united arab emirates': 'Asia/Dubai',
  'uae': 'Asia/Dubai',
  'qatar': 'Asia/Qatar',
  'kuwait': 'Asia/Kuwait',
  'bahrain': 'Asia/Bahrain',
  'oman': 'Asia/Muscat',
  'lebanon': 'Asia/Beirut',
  'jordan': 'Asia/Amman',
  'iraq': 'Asia/Baghdad',
  'india': 'Asia/Kolkata',
  'pakistan': 'Asia/Karachi',
  'china': 'Asia/Shanghai',
  'japan': 'Asia/Tokyo',
  'south korea': 'Asia/Seoul',
  'singapore': 'Asia/Singapore',
  'australia': 'Australia/Sydney',
  'new zealand': 'Pacific/Auckland',
};

export function getTimezoneForCountry(country) {
  if (!country) return null;
  return COUNTRY_TIMEZONE_MAP[country.toLowerCase().trim()] || null;
}

export default COUNTRY_TIMEZONE_MAP;
